export const footerAccordion = () => {
    const buttons = document.querySelectorAll<HTMLButtonElement>('.footer__section-button');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            button.classList.toggle('active');
            const sibling = button.nextElementSibling;
            if (sibling && sibling.classList.contains('link-list')) {
                sibling.classList.toggle('active');
            }
        });
    });
}

export const expandAccordionBySearchParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const linkParam = urlParams.get('link-to-footer');
    
    if (linkParam) {
        const link = document.querySelector<HTMLAnchorElement>(`.footer a[href="${linkParam}"]`);
        
        if (link) {
            link.classList.add('highlight');
            const footerSection = link.closest('.footer__section');
            const accordionButton = footerSection 
                ? footerSection.querySelector<HTMLButtonElement>('.footer__section-button') 
                : null;
            
            if (accordionButton) {
                accordionButton.classList.add('active');
                const sibling = accordionButton.nextElementSibling;
                
                if (sibling && sibling.classList.contains('link-list')) {
                    sibling.classList.add('active');
                }
            }
            setTimeout(() => {
                link.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center'
                });
            }, 250);

            link.addEventListener('mouseleave', () => {
                link.classList.remove('highlight');
            });
        }
    }
}